class ProductCompleteLook extends HTMLElement {
    constructor() {
        super();
        this.productForm = null;
        this.selectedVariants = new Map();
        this.productItems = this.querySelectorAll('.complete-look-item');
        this.addToCartButton = this.querySelector('.product-complete-look-button button');
        this.messageContainer = this.querySelector('.product-complete-look-message-container');
        this.initializeDefaultVariants();

    }
    initializeDefaultVariants() {
        this.productItems.forEach(item => {
            const defaultSelected = item.querySelector('input[type="radio"]:checked');
            if (defaultSelected) {
                const variantId = defaultSelected.value;
                const productHandle = defaultSelected.name.replace('select-size', '');
                this.selectedVariants.set(productHandle, variantId);

                // Update selected value text
                const selectedText = item.querySelector('[id$="-selected-value"]');
                if (selectedText) {
                    selectedText.textContent = defaultSelected.closest('label').textContent.trim();
                }
            }
        });
    }

    connectedCallback() {
        this.setupEventListeners();
    }

    setupEventListeners() {
        // Handle variant selection changes
        this.productItems.forEach(item => {
            const variantButtons = item.querySelectorAll('input[type="radio"]');
            variantButtons.forEach(button => {
                button.addEventListener('change', (event) => {
                    this.handleVariantChange(event, item);
                });
            });
        });

        // Handle add to cart button
        if (this.addToCartButton) {
            this.addToCartButton.addEventListener('click', () => this.addSetToCart());
        }
    }

    handleVariantChange(event, productItem) {
        const variantId = event.target.value;
        const productHandle = event.target.name.replace('select-size', '');
        this.selectedVariants.set(productHandle, variantId);

        // Update selected value text
        const selectedText = productItem.querySelector('[id$="-selected-value"]');
        if (selectedText) {
            selectedText.textContent = event.target.closest('label').textContent.trim();
        }
        console.log(this.selectedVariants)
    }


    showMessage(message, isError = false) {
        this.messageContainer.textContent = message;
        this.messageContainer.className = `product-complete-look-message-container ${isError ? 'message-error' : 'message-success'}`;
        this.messageContainer.style.display = 'block';

        setTimeout(() => {
            this.messageContainer.style.display = 'none';
        }, 3000);
    }

    async addSetToCart() {
        try {
            const items = Array.from(this.selectedVariants.values()).map(id => ({
                id: parseInt(id),
                quantity: 1
            }));

            if (items.length < this.productItems.length) {
                this.showMessage('Please select product options', true);
                return;
            }

            const response = await fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ items })
            });

            if (!response.ok) {
                throw new Error('Network response was not ok');
            }

            // window.dispatchEvent(new CustomEvent('cart:refresh'));
            // this.showMessage('Products added to cart', false);

            window.SLIDECART_UPDATE(()=>{window.SLIDECART_OPEN()})



        } catch (error) {
            console.error('Error adding products to cart:', error);
            this.showMessage('Failed to add products to cart', true);
        }
    }
}

// Register the custom element
customElements.define('product-complete-look', ProductCompleteLook);

function setViewportHeightMob(selector){
    if (window.innerWidth >= 700) return;

    const target = document.querySelector(selector);
    if (!target) return;

    const header = document.querySelector('.shopify-section--header');
    const announcement = document.querySelector('.shopify-section--announcement-bar');

    const headerHeight = header ? header.offsetHeight : 0;
    const announcementHeight = announcement ? announcement.offsetHeight : 0;

    const totalOffset = headerHeight + announcementHeight;

    const visibleHeight = window.innerHeight - totalOffset;

    target.style.height = `${visibleHeight}px`;
}
function initProductSliders() {
    // Get all slider containers
    const sliders = document.querySelectorAll('.section-reviews:not(.section-reviews-v2)');

    // Initialize each slider
    sliders.forEach((slider, index) => {
        const uniqueId = `complete-look-slider-${index}`;
        slider.id = uniqueId;

        // Create navigation buttons
        const prevButton = slider.querySelector('.slider-button-prev');
        const nextButton = slider.querySelector('.slider-button-next');

        // Initialize Swiper
        new Swiper(`#${uniqueId} .section-reviews-slider`, {
            slidesPerView: 1.11,
            spaceBetween: 12,
            loop: true,
          scrollOnFocus: false,
            navigation: {
                prevEl: prevButton,
                nextEl: nextButton,
                disabledClass: 'slider-button-disabled',
            },
            breakpoints: {
                550: {
                    slidesPerView: 2.5
                },
                767: {
                    slidesPerView: 3,
                    spaceBetween: 16,
                },
                1024: {
                    slidesPerView: 4,
                    spaceBetween: 16,
                },
                1440: {
                    slidesPerView: 5,
                    spaceBetween: 16,
                }
            }
        });
    });
}
function initVideoPlayers() {
    const videoContainers = document.querySelectorAll('.video-container');

    videoContainers.forEach(container => {
        const video = container.querySelector('video');
        const playButton = container.querySelector('.video-play-button');
        let isPlaying = false;

        if (!video || !playButton) return;

        playButton.addEventListener('click', (e) => {
          e.preventDefault();
            if (isPlaying) {
                video.pause();
                playButton.classList.remove('playing');
            } else {
                video.play();
                playButton.classList.add('playing');
            }
            isPlaying = !isPlaying;
        });

        video.addEventListener('ended', () => {
            isPlaying = false;
            playButton.classList.remove('playing');
        });
    });
}

function initCollectionsMenuSlider() {
    const menu_slider = document.querySelector('.linklist-collections__container');

    if(menu_slider != null){
        new Swiper(menu_slider, {
            slidesPerView: 'auto',
            spaceBetween: 8,
        });
    }
}

function initProductSlidersReviewsV2() {
    const prevButtonMob = document.querySelector('.section-reviews-v2 .slider-button-prev');
    const nextButtonMob = document.querySelector('.section-reviews-v2 .slider-button-next');

    const prevButtonDesc = document.querySelector('.section-reviews-v2 .container > .section-reviews-slider-arrows .slider-button-prev');
    const nextButtonDesc = document.querySelector('.section-reviews-v2 .container > .section-reviews-slider-arrows .slider-button-next');

    const swiper = new Swiper(".section-reviews-v2 .section-reviews-slider", {
        slidesPerView: 'auto',
        spaceBetween: 12,
        centeredSlides: true,
        speed: 600,
        loop: true,
        simulateTouch: true,
        grabCursor: true,
        navigation: {
            prevEl: [prevButtonMob, prevButtonDesc],
            nextEl: [nextButtonMob, nextButtonDesc],
        },
        on: {
            init(swiperInstance) {
                updateFarSlides(swiperInstance);
            },
            slideChange(swiperInstance) {
                updateFarSlides(swiperInstance);
            },
        }
    });

    function updateFarSlides(swiperInstance) {
        const slides = swiperInstance.slides;
        const activeIndex = swiperInstance.activeIndex;
        const totalSlides = slides.length;

        slides.forEach((slide, index) => {
            slide.classList.remove(
                'swiper-slide-prev',
                'swiper-slide-next',
                'swiper-slide-active',
                'left-far',
                'right-far'
            );

            if (index === activeIndex) {
                slide.classList.add('swiper-slide-active');
            } else if (index === (activeIndex - 1 + totalSlides) % totalSlides) {
                slide.classList.add('swiper-slide-prev');
            } else if (index === (activeIndex + 1) % totalSlides) {
                slide.classList.add('swiper-slide-next');
            } else if (index === (activeIndex - 2 + totalSlides) % totalSlides) {
                slide.classList.add('left-far');
            } else if (index === (activeIndex + 2) % totalSlides) {
                slide.classList.add('right-far');
            }
        });
    }
}


function initFancybox(){
    if (window.innerWidth < 769) {
        Fancybox.bind("[data-fancybox]", {
            Image: {
                zoom: true,
            },
            plugins: {
                ImageZoom: Fancybox.Plugins.ImageZoom
            }
        });
    }else{
        let elementsFancybox = document.querySelectorAll('[data-fancybox]');
        if(elementsFancybox.length > 0){
            elementsFancybox.forEach(el => {
                el.style.cursor = 'default';
                el.addEventListener('click', (e) => {
                    e.preventDefault();
                })
            })
        }
    }
}

function initReviewGalleryFancybox() {
    const buttons = document.querySelectorAll('.section-reviews-v2 .section-reviews-slider-item-preview-btn');

    buttons.forEach(button => {
        button.addEventListener('click', () => {
            const itemWrapper = button.closest('.section-reviews-slider-item-image-wrapper');
            if (!itemWrapper) return;

            const clickedLink = itemWrapper.querySelector('.section-reviews-slider-item-image');
            if (!clickedLink || !clickedLink.dataset.mediaSrc) return;

            const galleryLinks = Array.from(document.querySelectorAll('.section-reviews-v2 .section-reviews-slider-item-image'))
                .filter(link => link.dataset.mediaSrc && link.dataset.mediaType);

            const startIndex = galleryLinks.indexOf(clickedLink);
            if (startIndex === -1) return;

            const galleryItems = galleryLinks.map(link => {
                const src = link.dataset.mediaSrc;
                const type = link.dataset.mediaType;
                const thumb = link.querySelector('img')?.src || link.querySelector('video')?.getAttribute('poster');

                if (type === 'video') {
                    return {
                        src: `
                            <div class="fancybox-custom-video" style="max-width: 100%; max-height: 100%;">
                                <video controls autoplay playsinline muted style="width: 100%; height: auto;">
                                    <source src="${src}" type="video/mp4" />
                                    Your browser does not support the video tag.
                                </video>
                            </div>
                        `,
                        type: 'html',
                        thumb
                    };
                }

                return {
                    src,
                    type: 'image',
                    thumb
                };
            });

            Fancybox.show(galleryItems, {
                groupAll: false,
                startIndex
            });
        });
    });
}

function initControlsButtonVideo() {
    document.querySelectorAll('.section-video-content .custom-video, .product-gallery__media .custom-video').forEach(video => {
        video.removeAttribute('controls');
        console.log('video', video);
        const container = video.closest('.section-video-content__video-wrapper, .video-text__video, .product-gallery__media');
        const btnPlay = container.querySelector('.btn-toggle-play');
        const btnMute = container.querySelector('.btn-toggle-mute');

        btnPlay.addEventListener('click', () => {
            if (video.paused) {
                video.play();
                btnPlay.classList.remove('is-paused');
                btnPlay.classList.add('is-playing');
            } else {
                video.pause();
                btnPlay.classList.remove('is-playing');
                btnPlay.classList.add('is-paused');
            }
        });

        setTimeout(()=>{
            const hasAudio = video.mozHasAudio || video.webkitAudioDecodedByteCount > 0 || (video.audioTracks && video.audioTracks.length > 0);

            if (hasAudio) {
                btnMute.addEventListener('click', () => {
                    video.muted = !video.muted;

                    if (video.muted) {
                        btnMute.classList.remove('is-unmuted');
                        btnMute.classList.add('is-muted');
                    } else {
                        btnMute.classList.remove('is-muted');
                        btnMute.classList.add('is-unmuted');
                    }
                });
            } else {
                btnMute.style.display = 'none';
            }
        },500)
    });
}
function initReviewSliderSwipeVideo() {
    let reviewsVideo = document.querySelectorAll('.section-reviews-slider-item-image video');
    if (reviewsVideo.length > 0) {

        reviewsVideo.forEach(video => {
            let touchStartX = 0;
            let touchEndX = 0;

            video.addEventListener('touchstart', (e) => {
                touchStartX = e.changedTouches[0].screenX;
            });

            video.addEventListener('touchend', (e) => {
                touchEndX = e.changedTouches[0].screenX;
                handleSwipe(video);
            });

            function handleSwipe(currentVideo) {
                const swipeDistance = touchEndX - touchStartX;

                if (Math.abs(swipeDistance) > 30) {
                    const currentItem = currentVideo.closest('.section-reviews-slider-item-image');
                    if (!currentItem) return;

                    const allItems = Array.from(document.querySelectorAll('.section-reviews-slider-item-image'));

                    const currentIndex = allItems.indexOf(currentItem);

                    let nextItem = null;

                    if (swipeDistance < 0 && currentIndex < allItems.length - 1) {
                        nextItem = allItems[currentIndex + 1];
                    } else if (swipeDistance > 0 && currentIndex > 0) {
                        nextItem = allItems[currentIndex - 1];
                    }

                    if (nextItem) {
                        const nextVideo = nextItem.querySelector('video');
                        if (nextVideo) {
                            currentVideo.pause();
                            nextVideo.play().catch(err => {
                                console.warn('Video play error:', err);
                            });
                            nextItem.classList.add('video-playing');
                            const playBtn = nextItem.querySelector('.section-reviews-slider-item-play-button');
                            console.log('nextItem', nextItem);
                            if (playBtn) {
                                playBtn.classList.add('playing');
                            }
                        } else {
                            console.warn('Next item does not contain video');
                        }
                    } else {
                        console.log('No next/previous item found');
                    }
                }
            }
        });
    }
}






document.addEventListener('DOMContentLoaded', () => {
    setViewportHeightMob('main .slideshow .full-height-slide img');
    initProductSliders();
    initCollectionsMenuSlider();
    initProductSlidersReviewsV2();
    initFancybox();
    initReviewGalleryFancybox();
    initVideoPlayers();
    initControlsButtonVideo();
    initReviewSliderSwipeVideo();
});